"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _settings = _interopRequireDefault(require("../settings"));
var CDN_BASES = ['https://assets.nobiadigital.com/image', 'https://res.cloudinary.com/dgg9enyjv/image', 'https://dgg9enyjv-ressh.cloudinary.com/image'];
var _default = exports.default = function _default(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    width = _ref.width,
    height = _ref.height,
    _ref$crop = _ref.crop,
    crop = _ref$crop === void 0 ? 'fill' : _ref$crop,
    _ref$extension = _ref.extension,
    extension = _ref$extension === void 0 ? 'jpg' : _ref$extension;
  return function (key) {
    if (key === void 0) {
      key = 'missing';
    }
    var isAbsolute = key && key.startsWith('http');
    var isCloudinaryImage = key && CDN_BASES.some(function (base) {
      return key.startsWith(base);
    });
    var restrictions = [];
    if (width != null) {
      restrictions.push("w_" + width);
    }
    if (height != null) {
      restrictions.push("h_" + height);
    }
    if (width != null && height != null) {
      restrictions.push("c_" + crop);
    }
    restrictions.push("f_auto");
    if (isCloudinaryImage) {
      var cloudinaryValues = key.split(/\/(v\d+\/.*)/);
      return [cloudinaryValues[0], restrictions.length && restrictions.join(','), cloudinaryValues[1]].filter(Boolean).join('/');
    }
    var version = null;
    var image = key || 'missing';
    var values = key && key.split('/');
    if (!isAbsolute && key && key.toLowerCase().startsWith('v') && values.length === 2) {
      version = values[0];
      image = values[1];
    }
    var cloudinaryPath = key === 'missing' ? _settings.default.brand + "/" + image + "." + extension : "" + (version ? version + '/' : '') + _settings.default.brand + "/PIMImages/" + image + "." + extension;
    var path = isAbsolute ? key : cloudinaryPath;
    return [CDN_BASES[0], isAbsolute ? 'fetch' : 'upload', restrictions.length && restrictions.join(','), _settings.default.productImagePlaceholder && "d_" + _settings.default.brand + ":" + _settings.default.productImagePlaceholder.replace('/', ':') + "." + extension, path].filter(Boolean).join('/');
  };
};